import classNames from "classnames";
import { html } from "lit-html";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";

export const name = "ac-change-passenger-number-button";
export const useShadowDOM = false;

export interface Props {
	type: "plus" | "minus";
	isDisabled: boolean;
	onClick: () => void;
}

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		type: host.type,
		isDisabled: host.isDisabled,
		onClick: host.onClick,
	};

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		props.onClick();
	};

	return html`
		<div
			class=${classNames(
				"relative h-6 w-6 rounded-full border border-solid ",
				"after:absolute after:left-1/2 after:top-1/2 after:h-0.5 after:w-2 after:-translate-x-1/2 after:-translate-y-1/2 after:transform after:content-['']",

				{
					"before:absolute before:left-1/2 before:top-1/2 before:h-2 before:w-0.5 before:-translate-x-1/2 before:-translate-y-1/2 before:transform before:content-['']":
						props.type === "plus",

					"cursor-pointer border-n-cyan": !props.isDisabled,
					"after:bg-n-cyan": !props.isDisabled,
					"md:hover:border-n-blue md:hover:bg-n-blue": !props.isDisabled,
					"md:hover:before:bg-white md:hover:after:bg-white": !props.isDisabled,
					"before:bg-n-cyan": props.type === "plus" && !props.isDisabled,

					"border-[#a1a1a1]": props.isDisabled,
					"after:bg-[#a1a1a1]": props.isDisabled,
					"before:bg-[#a1a1a1]": props.type === "plus" && props.isDisabled,
				}
			)}
			@click=${handleClick}
		></div>
	`;
};
